import * as React from 'react';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';

const Content: React.FC<{}> = () => {
  return (
    <>
      <h3 className="mb-3 text-xl font-semibold">
        <T kind="Add Participants to Group" />
      </h3>
      <div className="flex items-center justify-center mt-8 w-full">
        <div className="text-md">
          <T kind="You need at least one group in order to..." />
        </div>
      </div>
    </>
  );
};

export default observer(Content);
